import 'core-js/es/map';
import 'core-js/es/set';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';

import 'material-license';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {store, persistor} from './redux/configStore';
import './i18n';
import Loader from 'components/Loader';
import './consoleLogWrapper';

// import 'api/_injects';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
   <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
         <App />
      </PersistGate>
   </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
